import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMouseCursor = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M28.2473 16.6395H26.8541M5.64065 16.6395H4.24741M24.9143 8.31851L23.5807 9.59874M7.61213 24.9869L8.9457 23.7066M7.58173 8.34892L8.91529 9.6279M24.9433 24.959L23.6097 23.6787M16.2469 26.8785V28.1587M16.2469 5.12V6.40023M20.4084 18.3435L17.9709 18.8678C17.8996 18.8827 17.8373 18.9251 17.7984 18.9835L16.6244 20.7457C16.0536 21.6038 14.6876 21.3722 14.4553 20.3796L13.1452 14.1341C12.913 13.1379 14.0507 12.3708 14.9471 12.9162L20.786 16.2588C21.6836 16.8055 21.4449 18.1206 20.4084 18.3435Z",
		stroke: "#596180",
		strokeWidth: 1.8,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMouseCursor;
